import { createCustomElement } from "@angular/elements";
import { createApplication } from "@angular/platform-browser";
import { OverlayContainerComponent } from "@core/overlay-override";
import {
	TradeCostAnalysisWidgetContainerComponent,
	TradeCostAnalysisWidgetSummaryComponent
} from "@features/trade-cost-analysis";
import "zone.js";
import { appConfig } from "./app/app.config";

createApplication(appConfig)
	.then((app) => {
		const tradeCostAnalysisWidget = createCustomElement(TradeCostAnalysisWidgetContainerComponent, {
			injector: app.injector
		});
		customElements.define("tenora-trade-cost-analysis", tradeCostAnalysisWidget);

		const tradeCostAnalysisWidgetSummary = createCustomElement(TradeCostAnalysisWidgetSummaryComponent, {
			injector: app.injector
		});
		customElements.define("tenora-trade-cost-analysis-summary", tradeCostAnalysisWidgetSummary);

		const tenoraOverlay = createCustomElement(OverlayContainerComponent, {
			injector: app.injector
		});
		customElements.define("tenora-overlay-container", tenoraOverlay);
	})
	.catch();
